/** @format */
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OtmId, TimingTemplate } from 'common-typescript/types';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ActiveTimingTemplateService {
    constructor(private readonly _httpClient: HttpClient) {}

    /**
     * The returned Observable will emit all 'ACTIVE' timing templates for the given module and then complete.
     */
    getActiveTimingTemplates(moduleId: OtmId): Observable<TimingTemplate[]> {
        return this._httpClient.get<TimingTemplate[]>('/kori/api/timing-templates', { params: new HttpParams().set('moduleId', moduleId) });
    }
}
